export const fetchPostApplication = async (sessionId: string, theme: string, application: string) => {
	try {
		const formData = new FormData();

		formData.append('method', 'create_ticket');
		formData.append('session_id', sessionId);
		formData.append('ticket_text', application);
		formData.append('subj', theme);
		formData.append('parent_id', 'null');

		const API = import.meta.env.VITE_API_BASE_URL;
		const url = `${API}/carbon`;

		const response = await fetch(url, {
			method: 'POST',
			body: formData,
		});

		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}

		const data = await response.json();

		return data;
	} catch (error) {
		console.error('Fetch error:', error);
		throw error;
	}
};
